module.exports = __webpack_public_path__ + "static/img/interactionLive07.16b89a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive07.png
// module id = FSzj
// module chunks = 0